import { render, staticRenderFns } from "./TreatmentUpsertModal.vue?vue&type=template&id=93ebe13c"
import script from "./TreatmentUpsertModal.vue?vue&type=script&lang=js"
export * from "./TreatmentUpsertModal.vue?vue&type=script&lang=js"
import style0 from "./TreatmentUpsertModal.vue?vue&type=style&index=0&id=93ebe13c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports